import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initializeTelemetry } from './services/telemetry/appInsights'
import './index.css'
import App from './App.tsx'

initializeTelemetry()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
